import {EventEmitter, Injectable} from "@angular/core";

import { Error } from "./error";

@Injectable()
export class ErrorService {
    showNotification = new EventEmitter<Error>();

    showInfo(summary: string, detail: string) {
        const errorData = new Error("info",summary,detail);
        this.showNotification.emit(errorData);
    }

    showWarn(summary: string, detail: string) {
        const errorData = new Error("warn",summary,detail);
        this.showNotification.emit(errorData);
    }

    showError(summary: string, detail: string) {
        const errorData = new Error("error",summary,detail);
        this.showNotification.emit(errorData);
    }

    showSuccess(summary: string, detail: string) {
        const errorData = new Error("success",summary,detail);
        this.showNotification.emit(errorData);
    }
}


// WEBPACK FOOTER //
// ./src/app/common/errors/error.service.ts